import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, e as escape, v as validate_component, i as each } from "../../../../../chunks/ssr.js";
import { g as goto } from "../../../../../chunks/client.js";
import "../../../../../chunks/api.js";
import { S as SortableTable } from "../../../../../chunks/SortableTable.js";
import { P as Pagination } from "../../../../../chunks/Pagination.js";
import { e as employeeStatus } from "../../../../../chunks/options.js";
import dayjs from "dayjs";
import { p as page } from "../../../../../chunks/stores.js";
import { S as SearchFilter } from "../../../../../chunks/SearchFilter.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { D as Dropdown } from "../../../../../chunks/Dropdown.js";
import { C as Checkbox } from "../../../../../chunks/Checkbox.js";
import { C as ChevronDownOutline } from "../../../../../chunks/ChevronDownOutline.js";
import { G as GlobalShortcuts } from "../../../../../chunks/GlobalShortcuts.js";
function employeeComplete(employee) {
  if (!employee.firstName || !employee.lastName || !employee.maidenName || !employee.gender || !employee.mobile || !employee.status) {
    return false;
  }
  if (!employee.cv.nationality || !employee.cv.degree || !employee.cv.religiousAffiliation || !employee.cv.taxationClass || !employee.cv.height || !employee.cv.shoeSize || !employee.cv.pantsSize || !employee.cv.shirtSize || !employee.cv.graduation || !employee.cv.familyStatus || !employee.cv.placeOfBirth || !employee.cv.countryOfBirth || !employee.cv.hairColor) {
    return false;
  }
  if (!employee.healthInsurance.insuranceName) {
    return false;
  }
  if (!employee.bankAccount.iban || !employee.bankAccount.accountName) {
    return false;
  }
  return true;
}
const DataTrafficLight = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let color;
  let { item } = $$props;
  if ($$props.item === void 0 && $$bindings.item && item !== void 0) $$bindings.item(item);
  color = employeeComplete(item) ? "bg-green-500" : "bg-red-500";
  return `<div class="${"rounded-2xl w-5 h-5 " + escape(color, true)}"></div>`;
});
let ReadEmployees = () => [
  {
    label: "Beworben am",
    property: "createdAt",
    sortable: true,
    movable: true,
    hidden: true,
    render: (data) => dayjs(data.createdAt.value).format("DD.MM.YYYY")
  },
  {
    label: "Stammdaten",
    property: "index",
    sortable: true,
    movable: true,
    hidden: false,
    component: DataTrafficLight
  },
  {
    label: "PNR",
    property: "employeeNumber",
    sortable: true,
    movable: true,
    hidden: true,
    render: (data) => data.employeeNumber || "Nicht vergeben"
  },
  {
    label: "Vorname",
    property: "firstName",
    sortable: true,
    movable: true
  },
  {
    label: "Nachname",
    property: "lastName",
    sortable: true,
    movable: true
  },
  {
    label: "E-Mail",
    property: "email",
    sortable: true,
    movable: true,
    hidden: true
  },
  {
    label: "Telefon",
    property: "mobile",
    sortable: true,
    movable: true,
    hidden: true
  },
  {
    label: "Status",
    property: "employmentStatus",
    render: (data) => employeeStatus[data.employmentStatus] ?? "Unbekannt"
  },
  {
    label: "Bereich",
    property: "area",
    sortable: true,
    movable: true
  },
  {
    label: "Vertragsbeginn",
    property: "contract_history.startDate",
    render: activeOrUpcomingContract,
    sortable: true,
    movable: true,
    customSort: (a, b, c) => a?.currentContract?.currentHistory?.startDate?.stamp < b?.currentContract?.currentHistory?.startDate?.stamp ? c : -1 * c
  }
];
const activeOrUpcomingContract = (data) => {
  let start = null;
  if (data.currentContract) {
    start = dayjs(data.currentContract.currentHistory?.startDate?.value);
  }
  if ((!start || start.isBefore(dayjs())) && data.contracts.length > 0) {
    const lastContract = data.contracts[data.contracts.length - 1];
    start = dayjs(lastContract.currentHistory?.startDate?.value);
  }
  return start ? start.format("DD.MM.YYYY") : "n/a";
};
if (typeof document !== "undefined") {
  new URL(document.location.href).searchParams;
}
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let pagination;
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { data } = $$props;
  let header = ReadEmployees();
  let additionalFields = {
    createdAt: false,
    employeeNumber: false,
    email: false,
    mobile: false,
    index: true
  };
  $page.url.searchParams.get("search") || "";
  const filterOptions = Object.entries(employeeStatus).map((item) => ({ label: item[1], value: item[0] }));
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    pagination = $page.data.paginated_data;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-1jyzzp1_START -->${$$result.title = `<title>${escape(employeeStatus[data.employmentStatus])}</title>`, ""}<!-- HEAD_svelte-1jyzzp1_END -->`, ""} <section>${validate_component(SearchFilter, "SearchFilter").$$render($$result, {}, {}, {
      cta: () => {
        return `<div slot="cta"><div class="flex gap-3">${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Status
                    ${validate_component(ChevronDownOutline, "ChevronDownOutline").$$render($$result, { class: "w-3 h-3 ml-2" }, {}, {})}`;
          }
        })} ${validate_component(Dropdown, "Dropdown").$$render($$result, { class: "w-52 p-3 space-y-3 text-sm" }, {}, {
          default: () => {
            return `${each(filterOptions, (option) => {
              return `<li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800 whitespace-nowrap" role="menuitem" tabindex="-1">${escape(option.label)}</button> </li>`;
            })} <li><button class="text-gray-700 block px-4 py-2 text-sm hover:text-neutral-800 whitespace-nowrap" role="menuitem" tabindex="-1" data-svelte-h="svelte-sfaauo">Alle</button></li>`;
          }
        })} ${validate_component(Button, "Button").$$render($$result, {}, {}, {
          default: () => {
            return `Felder
                    ${validate_component(ChevronDownOutline, "ChevronDownOutline").$$render($$result, { class: "w-3 h-3 ml-2" }, {}, {})}`;
          }
        })} ${validate_component(Dropdown, "Dropdown").$$render($$result, { class: "w-52 p-3 space-y-3 text-sm" }, {}, {
          default: () => {
            return `<li>${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              { checked: additionalFields.employeeNumber },
              {
                checked: ($$value) => {
                  additionalFields.employeeNumber = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `PNR`;
                }
              }
            )}</li> <li>${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              { checked: additionalFields.index },
              {
                checked: ($$value) => {
                  additionalFields.index = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `Datenampel`;
                }
              }
            )}</li> <li>${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              { checked: additionalFields.email },
              {
                checked: ($$value) => {
                  additionalFields.email = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `E-Mail`;
                }
              }
            )}</li> <li>${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              { checked: additionalFields.mobile },
              {
                checked: ($$value) => {
                  additionalFields.mobile = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `Telefon`;
                }
              }
            )}</li> <li>${validate_component(Checkbox, "Checkbox").$$render(
              $$result,
              { checked: additionalFields.createdAt },
              {
                checked: ($$value) => {
                  additionalFields.createdAt = $$value;
                  $$settled = false;
                }
              },
              {
                default: () => {
                  return `Bewerbungsdatum`;
                }
              }
            )}</li>`;
          }
        })}</div></div>`;
      }
    })} ${validate_component(SortableTable, "SortableTable").$$render(
      $$result,
      {
        rowClick: (row) => goto("/employee/" + row.uuid),
        header,
        data: pagination.collection
      },
      {},
      {}
    )} <div class="mt-5">${validate_component(Pagination, "Pagination").$$render($$result, { pagination }, {}, {})}</div> ${validate_component(GlobalShortcuts, "GlobalShortcuts").$$render($$result, {}, {}, {})}</section>`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
